import { DirectionOrder } from "../../shared/enum/direction-order";

export type KeyValuePairObject<T = any> = { [key: string]: T | undefined };

export type MetadataPageable = {
	totalItems: number; // total number of elements
	itemsPerPage: number; // total number of elements per page
	currentPage: number; // current page number
	totalPages: number; // total pages number
};

export type PayloadResponseMetadata = KeyValuePairObject & MetadataPageable;

export type PageableOrder =
	| DirectionOrder.ASCENDING
	| DirectionOrder.DESCENDING;
export type PageableSort = { [key: string]: PageableOrder };

export interface Pageable {
	pageSize: number;
	pageNumber: number;
	sort: PageableSort;
}
  
  export interface BasePayload<T> {
    data: T;
  }
  
  export class PayloadRequest<T> implements BasePayload<T> {
    data: T;
    pageable?: Pageable;
  
    constructor(payload: { data: T; pageable?: Pageable }) {
      this.data = payload.data;
      this.pageable = payload.pageable;
    }
  }

  export interface AppException {
    errorMessage: string;
    errorCode?: string;
  }
  
  export class PayloadResponse<T, E extends AppException | unknown = unknown>
    implements BasePayload<T>
  {
    data: T;
    metadata?: KeyValuePairObject;
    links?: KeyValuePairObject<string>;
    exception?: E;
  
    constructor(payload: {
      data: T;
      metadata?: PayloadResponseMetadata;
      links?: KeyValuePairObject;
      exception?: E;
    }) {
      this.data = payload.data;
      this.metadata = payload.metadata;
      this.links = payload.links;
      this.exception = payload.exception;
    }
  }